import { fetcherNew1819 } from "@utils/fetcherNew1819";
import { fetcherPublic1819 } from "@utils/fetcherPublic1819";
import useSWR from "swr";
import { useState, useEffect } from "react";

export const useRegistrationDetails = (id) => {
    if (!id) return useSWR(null, fetcherNew1819);
    return useSWR(`1819/details?id=${id}`, fetcherNew1819);
};

export const useSearchSuggestions = (query) => {
    const [debouncedQuery, setDebouncedQuery] = useState(query);

    useEffect(() => {
        // Debounce fyrir 1 sekúndur
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 250);

        // Hreinsa timeout ef query breytist aftur áður en tíminn rennur út
        return () => {
            clearTimeout(handler);
        };
    }, [query]);

    // Don't fetch if query is empty, only whitespace, or too short
    if (!debouncedQuery || !debouncedQuery.trim() || debouncedQuery.trim().length < 2) {
        return useSWR(null, fetcherPublic1819);
    }
    return useSWR(`1819/suggest?query=${debouncedQuery}`, fetcherPublic1819);
};
